import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-employer-dashboard',
  templateUrl: './employer-dashboard.component.html',
  styleUrls: ['./employer-dashboard.component.css']
})
export class EmployerDashboardComponent implements OnInit {

  

  constructor() { }


  ngOnInit() {
  }

 

}
